export enum PLVIO_CALL_STATE {
    INITIALIZED = "initialized",
    RINGING = "ringing",
    ANSWERED = "answered",
    REJECTED = "rejected",
    IGNORED = "ignored",
    CANCELED = "canceled",
    FAILED = "failed",
    ENDED = "ended"
}

export enum PLIVO_CALL_STATUS_TEXT {
    HANGUP = "Hangup",
    ANSWERED = "Answered",
    INITIATED = "Initiated",
    RINGING = "Ringing"
}

export interface PlivoRemoteInfo {
    id?: string;
    plivo_hangup_cause?: string;
    plivo_hangup_cause_code?: string;
    answered_timestamp?: Date;
    hangup_json?: PlivoActionInfo;
    ringing_json?: PlivoActionInfo;
    billed_duration?: string;
    current_status?: PLIVO_CALL_STATUS_TEXT;
    call_uuid?: string;
    initiation_json?: PlivoActionInfo;
    hangup_timestamp?: Date;
    ringing_timestamp?: Date;
    plivo_hangup_source?: string;
    initiated_timestamp?: Date;
    answer_json?: PlivoActionInfo;
    duration?: string;
}

export interface PlivoActionInfo {
    STIRVerification?: string;
    From?: string;
    InitiationTime?: Date;
    AnswerTime?: string;
    BilledDuration?: string;
    To?: string;
    TotalAmount?: string;
    PlivoHangupCause?: string;
    Role?: string;
    PlivoHangupSource?: string;
    CallUUID?: string;
    MPCUUID?: string;
    RingTime?: string;
    MPCName?: string;
    Rate?: string;
    HangupTime?: string;
    EventName?: string;
    PlivoHangupCauseCode?: string;
    STIRAttestation?: string;
    Duration?: string;
}
